import React, {useEffect} from "react";
import CardProduct from "../../../../partials/card/CardProduct";
import {Col, Row} from "react-bootstrap";
import {useParams} from "react-router-dom";
import axios from "axios";
import {BASE_URL, MORE_PRODUCTS_ALL_POST} from "../../../../../../apis";
import qs from "querystring";
import {handelChangeListMoreProducts} from "../../../../../../redux/actions/pages/moreProducts";
import {useDispatch, useSelector} from "react-redux";
import SliderProducts from "../../../../partials/sliders/SliderProducts";
import {FaAngleDoubleLeft} from "react-icons/all";

const MoreProducts = () => {
    const {category} = useParams();
    const dispatch = useDispatch();
    const {listMoreProducts} = useSelector(state => state.moreProducts);

    useEffect(() => {
        getDataAllMoreProducts();
        // eslint-disable-next-line
    }, [category]);
    const getDataAllMoreProducts = () => {
        axios({
            method: 'post',
            url: BASE_URL + MORE_PRODUCTS_ALL_POST,
            data: qs.stringify({
                category: category
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        }).then((response) => {
            if (response.data.status === "ok") {
                dispatch(handelChangeListMoreProducts(response.data.products));
            }
        });
    };
    return (
        <div className={'base-box-page-more-products'}>
            {Object.keys(listMoreProducts).length > 0 ?
                <React.Fragment>
                    {Object.keys(listMoreProducts).length === 1 ?
                        <div className={'box-page-more-products'}>
                            <div className={'box-header-page-more-products'}>
                                <FaAngleDoubleLeft className={'icon-header-page-more-products'}/>
                                <h6 className={'txt-title-header-page-more-products'}>{Object.keys(listMoreProducts)[0]}</h6>
                            </div>
                            <div className={'box-list-items-page-more-products'}>
                                <Row>
                                    {typeof listMoreProducts[Object.keys(listMoreProducts)[0]].contents !== "undefined"
                                        ? listMoreProducts[Object.keys(listMoreProducts)[0]].contents.map((item) =>
                                            <Col xs={6} sm={4} md={3} lg={2} key={item.id}>
                                                <CardProduct product={item}/>
                                            </Col>)
                                        : ''}
                                </Row>
                            </div>
                        </div>
                        :
                        <div className={'base-page-more-design-two'}>
                            <Row>
                                {Object.keys(listMoreProducts).map((key, index) => {
                                    return (
                                        <Col key={index} xs={12}>
                                            <SliderProducts
                                                data={{title: key, contents: listMoreProducts[key].contents}}/>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </div>
                    }
                </React.Fragment>
                : ''}
        </div>
    );
};

export default MoreProducts;
